import React from "react";
import About from "./about us/About";
import MyNavbar from "../../../components/Buyer/navbar/MyNavbar";
import HeroSlider from "./heroSection/HeroSlider";
import FeatureProperty from "./featureProperty/FeatureProperty";
import Footer from "../../../components/Buyer/footer/Footer";
import Testimonial from "../../../subscreens/Buyer/testimonial/Testimonial";
import ContactUs from "./home contactUs/HomeContactUs";
import Proprty from "./property insight/ProprtyInsight";
import HomeAgents from "./agents/HomeAgents";
import AIDesignGen from "./aidesigngen/AIDesignGen";
const Home=()=>{
    return(
        <>
        <MyNavbar/>   
        <HeroSlider/>
        <About/> 
        <AIDesignGen/>
        <FeatureProperty/>
        <HomeAgents/>
        <Proprty/>
        <Testimonial/>
        {/* <ContactUs/> */}
        <Footer/>
        </>
    )
}
export default Home;